import { Dropdown, Menu, Modal, Space } from "antd"
import React, { useState } from "react"
import { DownOutlined } from '@ant-design/icons';
import "antd/dist/antd.css"
import { useDispatch, useSelector } from "react-redux"
import { changeCanvasSize } from "../../slices/creatorSlice"

const PageSize = ({ canvas }) => {
  const [isDropDownVisible, setIsDropDownVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [canvasSizeKey, setCanvasSizeKey] = useState("square")
  const _CanvasSize = useSelector((state) => state.creator.canvasSize)
  const dispatch = useDispatch()

  //dropdown will not close if user changing number of slides.
  const handleMenuClick = (e) => {
    if (e.key !== _CanvasSize.key) {
      setCanvasSizeKey(e.key)
      setIsModalVisible(true)
    }
  }

  const handleOk = () => {
    setIsModalVisible(false)
    switch (canvasSizeKey) {
      case "square":
        dispatch(
          changeCanvasSize({
            key: canvasSizeKey,
            width: 1080,
            height: 1080,
            scale: 0.7,
            marginTop: -140,
          })
        )

        break
      case "landscape":
        dispatch(
          changeCanvasSize({
            key: canvasSizeKey,
            width: 1080,
            height: 608,
            scale: 1.2,
            marginTop: 100,
          })
        )

        break
      case "portrait":
        dispatch(
          changeCanvasSize({
            key: canvasSizeKey,
            width: 1080,
            height: 1350,
            scale: 0.55,
            marginTop: -270,
          })
        )

        break

      default:
        break
    }
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  //change visibility after user choose any option
  const handleVisibleChange = (flag) => {
    setIsDropDownVisible(flag)
  }

  // this is our main drop down menu.
  const pageSizeOptions = () => {
    return (
      <Menu
        onClick={handleMenuClick}
        items={[
          {
            key: "portrait",
            label: (
              <div
                className={`${
                  _CanvasSize.key === "portrait"
                    ? "border border-blue-500 p-"
                    : "p-1"
                }`}
              >
                Portrait (1080 x 1350){" "}
              </div>
            ),
          },
          {
            key: "landscape",
            label: (
              <div
                className={`${
                  _CanvasSize.key === "landscape"
                    ? "border border-blue-500 p-1"
                    : "p-1"
                }`}
              >
                Landscape (1080 x 608)
              </div>
            ),
          },
          {
            key: "square",
            label: (
              <div
                className={`${
                  _CanvasSize.key === "square"
                    ? "border border-blue-500 p-1"
                    : "p-1"
                }`}
              >
                Square (1080 x 1080){" "}
              </div>
            ),
          },
        ]}
      />
    )
  }
  return (
    <>
      <Dropdown
        overlay={pageSizeOptions}
        className="cursor-pointer rounded-full last:mr-0 mr-2 bg-gray-100 text-xs flex items-center justify-center border-2 px-8 py-2 text-[#000000] "
        visible={isDropDownVisible}
        onVisibleChange={handleVisibleChange}
        trigger={['click']}
      >
        {/* eslint-disable-next-line */}
        <a href="#" onClick={(e) => e.preventDefault()}>
        <Space>
        Page Size
        
      </Space>
      {" "}
      <DownOutlined />
        </a>
      </Dropdown>
      <Modal
        title="Warning"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        Slide content may be misaligned, do you wish to continue?
      </Modal>
    </>
  )
}

export default PageSize
